import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('load-filter-component', {
    props: {
        loadMoreAmount: {
            type: Number,
            default: 4,
        },

        items: {
            type: Array,
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentIndex: 1,
            maxIndex: 1,
            noMoreItems: false,
            enabledCategories: [],
        };
    },

    computed: {
        formattedData() {
            let filteredItems = this.items.filter((item) => {
                for (let i = 0; i < this.enabledCategories.length; i++) {
                    if (item.categories.indexOf(this.enabledCategories[i]) !== -1) {
                        return item;
                    }
                }

                return false;
            });

            if (this.enabledCategories.length === 0) {
                filteredItems = this.items;
            }

            const formattedData = filteredItems.slice(0, (this.currentIndex * this.loadMoreAmount));
            return formattedData;
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.currentIndex = 1;
        this.maxIndex = Math.ceil(this.items.length / this.loadMoreAmount);

        if (this.items.length <= this.loadMoreAmount) {
            this.noMoreItems = true;
        }

        this.preLoadImages();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        loadNextItems() {
            if (this.currentIndex === this.maxIndex || this.currentIndex > this.maxIndex) {
                return;
            }

            this.currentIndex += 1;
            this.noMoreItems = this.currentIndex === this.maxIndex || this.currentIndex > this.maxIndex;

            this.preLoadImages();
        },

        setCategories(categoryId, filter) {
            if (!categoryId || this.enabledCategories.indexOf(categoryId) !== -1) {
                return;
            }

            this.enabledCategories = [...this.enabledCategories, categoryId];
            this.toggleFilter(filter);
        },

        removeFilter(categoryId, filter) {
            if (!categoryId) {
                return;
            }

            const index = this.enabledCategories.indexOf(categoryId);
            if (index === -1) {
                return;
            }

            this.enabledCategories.splice(index, 1);
            this.toggleFilter(filter);
        },

        toggleFilter(filter) {
            const target = this.$refs[filter];
            const filterBlock = target;
            const filterList = target.querySelector('.filter__options-container');

            if (filterBlock.classList.contains('active')) {
                filterBlock.classList.remove('active');
                gsap.to(filterList, 0.3, {
                    height: 0,
                    ease: 'Quad.easeOut',
                });
            } else {
                filterBlock.classList.add('active');
                gsap.to(filterList, 0.3, {
                    height: 'auto',
                    ease: 'power4.out',
                });
            }
        },

        preLoadImages() {
            if (this.noMoreItems) {
                return;
            }

            const nextIndex = this.currentIndex + 1;
            const nextItems = this.items.slice((this.currentIndex * this.loadMoreAmount), (nextIndex * this.loadMoreAmount));

            for (let i = 0; i < nextItems.length; i++) {
                if (nextItems[i].image) {
                    const img = new Image();
                    img.src = nextItems[i].image;
                }
            }
        },
    },
});
